export default __webpack_public_path__ + "static/media/household-keymap-4.8ea2b3dd.png";